import React from 'react';
import Form from 'react-bootstrap/Form'
import FormDelimiter from "../FormDelimiter";
import {ConsigneeAddress} from "../ConsigneeAddress";
import {PickupPointAddressBXB} from "./PickupPointAddressBXB";

export class DeliverTo {
    static door = 'door';
    static pickupPoint = 'pickup_point';
}

function RadioButtons(props) {
    const {
        handleChange,
        values,
    } = props;
    const doorRadio = (
        <Form.Check
            checked={values._deliverTo === DeliverTo.door}
            inline
            type="radio"
            name="_deliverTo"
            label="Courier Delivery"
            value={DeliverTo.door}
            id={DeliverTo.door}
            onChange={handleChange}
        />

    );
    const pickupPointRadio = (
        <Form.Check
            checked={values._deliverTo === DeliverTo.pickupPoint}
            inline
            type="radio"
            name="_deliverTo"
            label="Pickup Point"
            value={DeliverTo.pickupPoint}
            id={DeliverTo.pickupPoint}
            onChange={handleChange}
        />

    );
    if (values.lastMileService.code === 'BXB') {
        return (
            <div>
                {doorRadio}
                {pickupPointRadio}
            </div>
        )
    } else {
        return (
            <div>
                {doorRadio}
            </div>
        )
    }
}

export class Address extends React.Component {
    render() {
        const {values} = this.props;
        const {_deliverTo} = values;

        let address;
        if (_deliverTo === DeliverTo.door) {
            address = <ConsigneeAddress {...this.props}/>;
        } else if (_deliverTo === DeliverTo.pickupPoint && values.lastMileService.code === 'BXB') {
            address = <PickupPointAddressBXB {...this.props}/>;
        } else {
            address = null;
        }

        return (
            <div>
                <FormDelimiter text="ADDRESS"/>
                <RadioButtons {...this.props}/>
                {address}
            </div>
        )
    }
}
